import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import { getFontFamily } from '../../../badge/pdf/utils';
import { receiptA4Styles } from '../ReceiptPDFA4.styles';
import { getStringWithMultipleReplacements } from '../ReceiptPdf.utils';
import { receiptPriceReplacements } from '../ReceiptPdf.constants';
import { Style } from "@react-pdf/types";

interface Props {
  label: string;
  value: string;
  fallbackFontFamily?: string;
  boldLabel?: boolean;
  styles?: Partial<Record<'wrapper' | 'label' | 'value', Style[]>>;
}

export const FullWidthLabelValue: React.FC<Props> = ({
  label,
  value,
  styles = {
    label: [{}],
    value: [{}],
    wrapper: [{}]
  },
  fallbackFontFamily,
  boldLabel = true
}) => {

  return (
    <View style={[receiptA4Styles.paymentsInfoElement, ...(styles?.wrapper || [])]}>
      <Text style={[receiptA4Styles.textLeft, getFontFamily(label, { fallbackFont: fallbackFontFamily, bold: boldLabel }), ...(styles?.label || [])]}>{label.split('')}</Text>
      <Text style={[receiptA4Styles.textRight, ...(styles?.label || []), ...(styles?.value || [])]}>
        {getStringWithMultipleReplacements(value, receiptPriceReplacements).split('')}
      </Text>
    </View>
  );
};
